module.exports = "<igo-print-form\r\n  [format]=\"format\"\r\n  [orientation]=\"orientation\"\r\n  [resolution]=\"resolution\"\r\n  [disabled]=\"disabled\"\r\n  (submit)=\"handleFormSubmit($event)\">    \r\n</igo-print-form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/print/print/print.component.html
// module id = 1077
// module chunks = 0